import BigNumber from 'bignumber.js';

const MAX_UINT256 = new BigNumber(2).pow(256).minus(1);

export default MAX_UINT256;
